export default "__VITE_ASSET__08d66852__"